var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    rx: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.737 29.618 47.32 16.444h-2.744L34.518 27.883l-8.032-11.439h-9.264l12.146 17.297-12.146 13.815h2.745l10.62-12.08 8.482 12.08h9.264zm-3.759 4.276-1.23-1.723-9.792-13.705h4.215l7.902 11.06 1.231 1.723 10.272 14.377H40.36z"
  })));
};
export { SvgTwitter as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHJ4PSIzMiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0zNS43MzcgMjkuNjE4IDQ3LjMyIDE2LjQ0NGgtMi43NDRMMzQuNTE4IDI3Ljg4M2wtOC4wMzItMTEuNDM5aC05LjI2NGwxMi4xNDYgMTcuMjk3LTEyLjE0NiAxMy44MTVoMi43NDVsMTAuNjItMTIuMDggOC40ODIgMTIuMDhoOS4yNjR6bS0zLjc1OSA0LjI3Ni0xLjIzLTEuNzIzLTkuNzkyLTEzLjcwNWg0LjIxNWw3LjkwMiAxMS4wNiAxLjIzMSAxLjcyMyAxMC4yNzIgMTQuMzc3SDQwLjM2eiIgZmlsbD0iIzAwMCIvPjwvc3ZnPg==";